import { Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  Grid2,
  Link as MuiLink,
  TextField,
  Typography
} from '@mui/material';
import { useAuth } from '../AuthContext';
import { useCallback, useEffect, useState } from "react";
import { TERMS_URL, EMAIL_REGEX } from "../constants";

function formDataToJSON(formData) {
  const object = {};
  formData.forEach((value, key) => {
    object[key] = value === 'on' ? true : value;
  });
  return object;
}

export default function SignUp() {
  let navigate = useNavigate();
  let location = useLocation();
  let auth = useAuth();
  const [searchParams] = useSearchParams();

  const [userEmail, setUserEmail] = useState('');
  const [formError, setFormError] = useState({});
  const [isPending, setIsPending] = useState(false);
  const [verifyError, setVerifyError] = useState({});
  let from = location.state?.from?.pathname || "/";

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    setFormError({});
    
    let formData = new FormData(event.currentTarget);
    const data = formDataToJSON(formData);
    // data.inviteCode = inviteCode;
    // let email = formData.get("email");
    console.log('formData', data);
    // console.log('email', email);
    if (!data.email?.length || !EMAIL_REGEX.test(data.email)) {
      setFormError({ email: 'Please enter a valid email address' });
      return;
    }
    if (!data.password?.length || data.password.length < 8) {
      setFormError({ password: 'Your password is too short. Please select a password at least 8 characters long' });
      return;
    }
    if (data.password !== data.password2) {
      setFormError({ password: 'Your passwords do not match' });
      return;
    }
    setFormError({});
    setIsPending(true);

    auth.signup(data).then((user) => {
      console.log('User created!', user);
      // navigate('/account', { replace: true });
      const redirectUri = searchParams.get('redirect_uri');
      if (searchParams.get('source') === 'mobile' && redirectUri) {
        // Deep link back to the app — this dismisses the in-app browser
        window.location.href = redirectUri;
      } else {
        navigate('/account', { replace: true });
      }

    }).catch(error => {
      setFormError({ response: error.message });
      setIsPending(false);
    });
    // auth.signin(username, () => {
    //   // Send them back to the page they tried to visit when they were
    //   // redirected to the login page. Use { replace: true } so we don't create
    //   // another entry in the history stack for the login page.  This means that
    //   // when they get to the protected page and click the back button, they
    //   // won't end up back on the login page, which is also really nice for the
    //   // user experience.
    //   navigate(from, { replace: true });
    // });
  }, []);


  return (
    <Container maxWidth="sm" sx={{ p: 3 }}>
      <Typography variant="h3">Create an Account</Typography>
      {/* <Typography sx={{ my: 3 }}></Typography> */}

      <Typography variant="body2" color="textSecondary" sx={{ my: 3 }}>Get started for free! Create your OpenGolfSim account now.</Typography>
      <form onSubmit={handleSubmit}>
        <Grid2 container direction="column" spacing={3}>
          {/* <Grid2>
            <TextField name="username" label="Username" fullWidth />
          </Grid2> */}
          <Grid2>
            <TextField
              name="email"
              label="Email"
              fullWidth={true}
              required={true}
              error={formError.email}
              disabled={isPending}
              onChange={(e) => setUserEmail(e.target.value)}
              value={userEmail}
              helperText={formError.email}
            />
          </Grid2>
          <Grid2>
            <TextField
              name="password"
              label="Password"
              type="password"
              fullWidth={true}
              required={true}
              disabled={isPending}
              error={formError.password}
              helperText={formError.password}
            />
          </Grid2>
          <Grid2>
            <TextField
              name="password2"
              label="Retype Password"
              type="password"
              fullWidth={true}
              required={true}
              disabled={isPending}
              error={formError.password}
              helperText={formError.password}
            />
          </Grid2>
          <Grid2>
            <FormControlLabel
              required={true}
              disabled={isPending}
              control={<Checkbox name="terms" />}
              label={
                <>I agree to the OpenGolfSim <MuiLink href={TERMS_URL} target="_blank">Terms of Service</MuiLink></>
              }
            />
          </Grid2>
          <Grid2>
            <FormControlLabel disabled={isPending} control={<Checkbox name="marketing" defaultChecked />} label="I would like to receive updates and offers from OpenGolfSim" />
          </Grid2>
        </Grid2>
        <Button type="submit" sx={{ mt: 2 }} variant="outlined" disabled={isPending}>Create Account</Button>

        
        {formError.response ? (
          <Alert sx={{ mt: 3 }} severity="error">{formError.response}</Alert>
        ) : null}
      </form>

      <Box sx={{ mt: 5 }}>
        <Divider sx={{ mb: 2 }} />
        <Typography>
          Already have an account? 
          <Button to="/login" component={Link} sx={{ ml: 1 }}>Log in</Button>
        </Typography>
      </Box>
    </Container>
  );
}
